import { Slideshow } from './slideshow.js';
import { HTMLThemeElement } from './theme-element.js';
import { debounce } from './utils.js'

// Define your custom element class for the testimonial section
class CustomerTestimonialsSlider extends HTMLThemeElement {
    constructor() {
        super();
        // This is the container for your testimonials-grid that will become the slider
        this.sliderContainer = this.querySelector('.testimonials-grid');
        this.flickityInstance = null; // To hold the instance of Flickity wrapped in Slideshow class
    }

    // Lifecycle method called when the element is added to the DOM
    connectedCallback() {
        super.connectedCallback(); // Call parent's connectedCallback

        if (this.sliderContainer) {
            this.initSlider(); // Initial setup

            // Re-evaluate slider on window resize, using the theme's debounce utility
            window.addEventListener(
                'resize',
                debounce(
                    300,
                    this.initSlider.bind(this)
                )
            );
        }
    }

    // Lifecycle method called when the element is removed from the DOM
    disconnectedCallback() {
        super.disconnectedCallback(); // Call parent's disconnectedCallback
        if (this.flickityInstance) {
            this.flickityInstance.destroy(); // Clean up Flickity instance
            this.flickityInstance = null;
        }
        // Remove resize listener to prevent memory leaks
        window.removeEventListener('resize', this.initSlider.bind(this));
    }

    // Section editor callbacks (important for editing experience)
    onSectionSelect() {
        this.initSlider(); // Re-initialize or ensure slider is active when selected in editor
    }

    onSectionDeselect() {
        // If you have autoPlay, you might want to pause it when deselected
        if (this.flickityInstance && this.flickityInstance.args.autoPlay) {
            this.flickityInstance.play(); // Assuming you want it to play again
        }
    }

    onBlockSelect({ detail: { blockId } }) {
        // If a block (testimonial) is selected in the editor, navigate to it
        const slide = this.querySelector(`[data-shopify-editor-block="${blockId}"]`); // Assuming block.shopify_attributes gives this
        if (slide && this.flickityInstance) {
            const index = Array.from(this.sliderContainer.children).indexOf(slide);
            if (index !== -1) {
                this.flickityInstance.goToSlide(index);
                // Pause if autoPlay is on and you want to stop on select
                if (this.flickityInstance.args.autoPlay) {
                    this.flickityInstance.pause();
                }
            }
        }
    }

    onBlockDeselect() {
        // Resume autoPlay if it was paused on block select
        if (this.flickityInstance && this.flickityInstance.args.autoPlay) {
            this.flickityInstance.play();
        }
    }

    initSlider() {
        const isDesktop = window.innerWidth > 768;
        new Slideshow(this.sliderContainer, {
            pageDots: true,
            prevNextButtons: false,
            imagesLoaded: true,
            draggable: true,
            groupCells: true,
            cellAlign: isDesktop ? 'left' : 'center',
            percentPosition: true,
            // Add any other Flickity options here that Slideshow constructor supports
            // e.g., fade: true if you want the fade effect from Flickity Fade
        });
    }
}

// Define the custom element name. This will be used in your Liquid.
customElements.define('customer-testimonials-slider', CustomerTestimonialsSlider);